import { useListAchLocationsQuery } from 'api/giftcard-ach-service/giftcard-ach-service';
import AutocompleteField from '../fields/autocomplete-field/autocomplete-field.component';
import { useMemo } from 'react';

type ACHCopyLocationFormProps = {
  label: string;
  'data-testid': string;
  isCopyFrom?: boolean;
};

const ACHCopyLocationForm = ({
  label,
  'data-testid': dataTestId,
  isCopyFrom = false,
}: ACHCopyLocationFormProps) => {
  const { data: achLocations = [], isLoading } = useListAchLocationsQuery();

  const nonPoolACHLocations = useMemo(
    () => achLocations.filter(loc => !loc.locationId.includes('POOL_ACCOUNT')),
    [achLocations],
  );

  const options = useMemo(() => {
    if (isCopyFrom)
      return nonPoolACHLocations
        .filter(loc => loc.overallStatus === 'VERIFIED')
        .map(loc => ({
          id: loc.locationId,
          label: loc.locationName,
        }));

    return nonPoolACHLocations.map(loc => ({
      id: loc.locationId,
      label: loc.locationName,
    }));
  }, [isCopyFrom, nonPoolACHLocations]);

  return (
    <AutocompleteField
      name="location"
      label={label}
      options={options}
      loading={isLoading}
      data-testid={dataTestId}
    />
  );
};

export default ACHCopyLocationForm;
